module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("企业服务")]), _vm._v(" "), _c('div', {
    staticClass: "colorright"
  }, [_c('div', {
    staticClass: "t_btn pointer",
    on: {
      "click": _vm.toapply
    }
  }, [_vm._v("提出需求")])])]), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [(_vm.list.length) ? _c('div', {
    staticStyle: {
      "min-height": "570px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "l_one bg-white",
      on: {
        "click": function($event) {
          return _vm.todetail(index)
        }
      }
    }, [_c('div', {
      staticClass: "l_top"
    }, [_c('div', {
      staticClass: "l_title flex justify-start align-center"
    }, [_c('div', {
      staticClass: "l_line"
    }), _vm._v(" "), _c('div', {
      staticClass: "l_text text-cut"
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "l_brief text-cut5"
    }, [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "l_bot flex justify-between align-center"
    }, [_c('div', {
      staticClass: "l_time"
    }, [_vm._v(_vm._s(item.createtime))]), _vm._v(" "), (item.status == 0) ? _c('div', {
      staticClass: "l_tip l_color1"
    }, [_vm._v("未处理")]) : _vm._e(), _vm._v(" "), (item.status == 1) ? _c('div', {
      staticClass: "l_tip l_color2"
    }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (item.status == 2) ? _c('div', {
      staticClass: "l_tip l_color2"
    }, [_vm._v("已办结")]) : _vm._e()])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.list.length && !_vm.load) ? _c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "min-height": "480px",
      "padding": "40px"
    }
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.showdetail
    },
    on: {
      "update:visible": function($event) {
        _vm.showdetail = $event
      }
    }
  }, [_c('div', {}, [_c('div', [_c('div', {}, [_c('div', {
    staticClass: "l_title flex justify-start align-center"
  }, [_c('div', {
    staticClass: "l_line"
  }), _vm._v(" "), _c('div', {
    staticClass: "l_text"
  }, [_vm._v("提交内容")])]), _vm._v(" "), _c('div', {
    staticClass: "new_brief"
  }, [_c('div', {
    staticStyle: {
      "color": "#8a8a8a",
      "font-size": "16px",
      "margin": "6px 0",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t提交标题：\n\t\t\t\t\t\t")]), _vm._v(_vm._s(_vm.showdata.title))]), _vm._v(" "), _c('div', {
    staticClass: "new_brief"
  }, [_c('div', {
    staticStyle: {
      "color": "#8a8a8a",
      "font-size": "16px",
      "margin": "6px 0",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t提交简述：\n\t\t\t\t\t\t")]), _vm._v(_vm._s(_vm.showdata.content))])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "color": "#8a8a8a",
      "font-size": "16px",
      "margin": "6px 0",
      "margin-right": "10px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t提交图片：\n\t\t\t\t\t\t")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, _vm._l((_vm.showdata.file), function(items, indexs) {
    return _c('el-col', {
      key: indexs,
      attrs: {
        "span": 8
      }
    }, [_c('div', [_c('el-image', {
      staticStyle: {
        "width": "250px",
        "height": "250px",
        "margin-bottom": "15px"
      },
      attrs: {
        "src": items,
        "fit": "fill"
      }
    })], 1)])
  }), 1)], 1), _vm._v(" "), (_vm.showdata.remark) ? _c('div', {}, [_c('div', {
    staticClass: "l_title flex justify-start align-center"
  }, [_c('div', {
    staticClass: "l_line"
  }), _vm._v(" "), _c('div', {
    staticClass: "l_text"
  }, [_vm._v("平台反馈")])]), _vm._v(" "), _c('div', {
    staticClass: "new_brief"
  }, [_c('div', {
    staticStyle: {
      "color": "#8a8a8a",
      "font-size": "16px",
      "margin": "6px 0",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t回复内容：\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.showdata.remark))]), _vm._v(" "), (_vm.showdata.hffile) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#8a8a8a",
      "font-size": "16px",
      "margin": "6px 0",
      "margin-right": "10px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t回复附件：\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "text-cut2",
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "color": "#b6b5b5",
      "text-decoration": "none"
    },
    attrs: {
      "target": "_blank",
      "href": _vm._f("addurl")(_vm.showdata.hffile)
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "height": "40px",
      "margin-right": "10px"
    },
    attrs: {
      "src": require("../../../static/assets/images/wenjian.png")
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t点击打开\n\t\t\t\t\t\t\t\t\t")])])])] : _vm._e()], 2) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fecd607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/service.vue
// module id = 399
// module chunks = 1